export const ContactPersonType = {
  BUSS: 'BUSS',
  FINA: 'FINA',
};

export const ContactPersonTitle = ['Mr', 'Ms', 'Mrs'];
